import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function CTA() {
    return (
        <section className="cta-section" data-testid="cta-section">
            <div className="cta-overlay" />
            <div className="container">
                <div className="cta-content">
                    <h2 className="cta-title">Do you need a loan?</h2>
                    <p className="cta-text">
                        If you need any kind of loan to fulfill your requirement, contact us by clicking on the button.
                    </p>
                    <Link to="/contact">
                        <Button size="lg" variant="outline" className="cta-btn" data-testid="cta-contact-btn">
                            Contact Now
                        </Button>
                    </Link>
                </div>
            </div>
        </section>
    );
};
